<template>
  <footer class="footer">
    <div class="footer-container">
      <div class="footer-top">
        <a @click="routeToLink('about-us')" class="footer-link">About Us</a>
        <a @click="routeToLink('contact-us')" class="footer-link">Contact Us</a>
        <a :href="'https://www.linkedin.com/company/g14c/'" target="_blank" class="linkedin-link"><img :src="require('@/assets/contact/linkedin.png')" alt="LinkedIn" class="linkedin-icon" /></a>
      </div>
      <div class="certifications">
        <a herf="#">CMMI-DEV Level 3</a>
        <a herf="#">CMMI-SVC Level 3</a>
        <a herf="#">ISO 9001</a>
        <a herf="#">ISO 20000</a>
        <a herf="#">ISO 27001</a>
      </div>
      <div class="footer-bottom">
        <div class="footer-bottom-left m-2">
          <span>&copy; G14C LLC All Rights Reserved</span>
        </div>
        <div class="footer-bottom-right m-2">
          <router-link to="/privacy-statement">Privacy Statement</router-link>
          <router-link to="/terms-of-use">Terms of Use</router-link>
           <router-link to="/accessibility">Accessibility</router-link>
        </div>
      </div>
    </div>
  </footer>
</template>

<script lang="ts" setup>
  import router  from "@/router";

  function routeToLink(link: any){
    router.push({ name: link })
    window.scrollTo(0, 0);
  }
</script>

<style scoped>
.footer-top{
  display: flex;
  align-items: center;
  justify-content: center;
  width: 100%;
  margin-top: 7px;
}
.certifications{
  display: flex;
  justify-content: center;
  width: 100%;
  margin-top: 15px;
  flex-wrap: wrap;
}
.footer-bottom{
  display: flex;
  justify-content: space-between;
  margin-top: 15px;
  margin-bottom: 15px;
}
.footer-bottom-left{
  justify-content: center;
  display: flex;
}
.footer-bottom-right{
  justify-content: center;
  display: flex;
}
.footer-top a, .certifications a, .footer-bottom .footer-bottom-right a{
  text-decoration: none;
  color: #333;
  margin-right: 40px;
}
.footer-top a:last-child, .certifications a:last-child, .footer-bottom .footer-bottom-right a:last-child{
  margin-right: 0;
}
.footer {
  width: 100%;
  height: 118px;
  background-color: #fff;
  display: flex;
  justify-content: space-between;
  align-items: center;
  padding: 10px 20px;
  height: 100%;
}
.footer-container {
  justify-content: space-between;
  width: 100%;
}
@media (max-width: 730px) {
  .footer-bottom{
    display: block;
  }
  .footer-bottom-right{
    margin-top: 12px;
  }
}
.footer-link{
  cursor: pointer;
}
.linkedin-link {
  display: flex;
}
.linkedin-icon {
  align-self: center;
  height: 1.5rem;
}
.linkedin-icon:hover {
  filter: grayscale(1);
}

</style>